import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import Style from './Project.cssmodule.less';
import { ModalTypes } from '../../Constants';
import { clickButton } from '../../actions/Modal';
import Button from '../CommonSet/Button';
import Title from '../CommonSet/Title';
import Media from '../CommonSet/Media';

class Project extends BaseComponent {
    constructor(props) {
        super(props);
        this.setTheme(props.theme);
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    setTheme(theme) {
        const themeStyle = this.getTheme(theme, 'PROJECT');
        this.Style = themeStyle || Style;
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    getTitleName() {
        let option = '';

        if (this.props.item.titleType) {
            option = ` ${this.props.item.titleType}`;
        }

        return `${this.Style.title} ${option}`;
    }

    createHtmlContent(contnet) {
        let contentHTML = '';

        if (contnet) {
            contentHTML = contnet.replace(/\*\*\*.*?\*\*\*/gim, (item) => {
                let block = item.substring(3, item.lastIndexOf('***'));
                return $('<div>')
                    .append(this.createRenderView(block))
                    .html();
            });
        }

        return contentHTML;
    }

    createContent() {
        let view = null;

        if (this.props.item.content) {
            view = (
                <div className={this.Style.content}>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: this.createHtmlContent(
                                this.props.item.content
                            ),
                        }}
                    />
                </div>
            );
        }

        return view;
    }

    createMediaView() {
        let view = null;
        const { item = {} } = this.props;
        const { media, params, checkScript } = item;

        if (media) {
            view = (
                <Media
                    className={this.Style.media}
                    media={media}
                    params={params}
                    checkScript={checkScript}
                    option={{
                        width: '580',
                        height: '327',
                    }}
                />
            );
        }

        return view;
    }

    createButtonView() {
        const { button, type = ModalTypes.INTRO } = this.props.item;
        let buttonText = '';

        if (button) {
            buttonText = button;
        } else if (this.props.theme === 'LINE') {
            buttonText = this.Utils.getLang('Buttons.confirm');
        } else {
            if (type === ModalTypes.INTRO) {
                buttonText = this.Utils.getLang('Buttons.get_started');
            } else if (
                type === ModalTypes.HINT ||
                type === ModalTypes.PREBUILT_HINT
            ) {
                buttonText = this.Utils.getLang('Buttons.confirm');
            } else if (type === ModalTypes.LECTURE) {
                return (
                    <div className={this.Style.buttonView}>
                        <Button
                            className={`${this.Style.button} ${
                                this.Style.negativeButton
                            }`}
                            onClick={(e) => this.handleButtonClick('cancel')}
                            text={this.Utils.getLang('Buttons.previous')}
                        />
                        <Button
                            className={this.Style.button}
                            onClick={(e) => this.handleButtonClick('done')}
                            text={this.Utils.getLang('Menus.course_done_study')}
                        />
                    </div>
                );
            }
        }

        return (
            <div className={this.Style.buttonView}>
                <Button
                    className={this.Style.button}
                    onClick={(e) => this.handleButtonClick('start')}
                    text={buttonText}
                />
            </div>
        );
    }

    getTitleBadge() {
        const lmsData = entrylms.getData() || {};
        const { type } = lmsData;
        let { badgeText } = this.props.item;
        if (typeof badgeText === 'string') {
            return badgeText;
        }
        switch (type) {
            case 'guide':
                badgeText = '따라하기';
                break;
            case 'mission':
                badgeText = '도전하기';
                break;
            case 'free':
                badgeText = '자유롭게 만들기';
                break;
            default:
                break;
        }

        return badgeText;
    }

    getIconBadge() {
        const { badgeIcon } = this.props.item;
        let icon;
        switch (badgeIcon) {
            case 'LECTURE':
                icon = this.Style.lecture;
                break;
            default:
                break;
        }
        return icon;
    }

    createBadge() {
        const badgeIcon = this.getIconBadge();
        const badgeTitle = this.getTitleBadge();
        return (
            <span>
                {badgeIcon && (
                    <div className={`${this.Style.badgeIcon} ${badgeIcon}`} />
                )}
                {badgeTitle && (
                    <div className={`${this.Style.badge}`}>{badgeTitle}</div>
                )}
            </span>
        );
    }

    render() {
        const {
            isHomework,
            isHomeworkLapse,
            isSubmit,
            isLastStudy,
            media = {},
        } = this.props.item;
        return (
            <div className={`${this.Style.project} ${media.category || ''}`}>
                <Title
                    className={this.getTitleName()}
                    onClose={(e) => this.handleButtonClick('close')}
                >
                    {this.createBadge()}
                    <div className={`${this.Style.titleText}`}>
                        {this.props.item.title}
                    </div>
                </Title>
                <div className={this.Style.contentView}>
                    {this.createContent()}
                    {this.createMediaView()}
                </div>
                {this.createButtonView()}
            </div>
        );
    }
}

Project.displayName = 'Project';
Project.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps
)(Project);



// WEBPACK FOOTER //
// ./components/ModalSet/Project.js